import { UserPass } from "@/interface/User";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private http: HttpClient) {}

  findbyemail(email: String): Observable<any> {
    return this.http.get<any>(
      `${environment.url}/apiUser/getidbyemail/` + email
    );
  }

  sendEmail(email: string): Observable<any> {
    let params = new HttpParams();
    params = params.append("email", email);
    return this.http.get<any>(`${environment.url}/forgot`, { params: params });
  }

  sendEmail1(email: string , id: any , empId: any , typeId: any ,statusLeave: any): Observable<any> {
    let params = new HttpParams();

    params = params.append("email", email);
    params = params.append("id", id);
    params = params.append("empId",empId);
    params = params.append("typeId" , typeId);
    params = params.append("statusLeave",statusLeave);

    return this.http.get<any>(`${environment.url}/approve`, { params: params });
  }

  sendEmail2(userEmail:string,userid: any , reasonLeave:any ,roleId1:any , typeLeave:any,period:any,totaldays:any,StDate:any , EdDate:any): Observable<any> {
    let params = new HttpParams();
    params = params.append("emailUser", userEmail);
    params = params.append("userid", userid);
    params = params.append("reasonLeave", reasonLeave);
    params = params.append("roleId1", roleId1);
    params = params.append("typeLeave", typeLeave);
    params = params.append("period", period);
    params = params.append("totaldays", totaldays);
    params = params.append("StDate", StDate);
    params = params.append("EdDate", EdDate);
    return this.http.get<any>(`${environment.url}/noti`, { params: params });
  }

  sendEmailForApproveTimeSheet(id:any, empId: any , statusTimesheet:any): Observable<any> {

    console.log(empId);
    let params = new HttpParams();
    params = params.append("TsId", id);
    params = params.append("empId",empId);
    params = params.append("statusTimesheet",statusTimesheet)
    return this.http.get<any>(`${environment.url}/ap2`, { params: params });
  }


  sendEmailForSubmitTimeSheet(id:any, empId: any): Observable<any> {

    console.log(empId);
    console.log(typeof id)
    let params = new HttpParams();
    params = params.append("TsId", id);
    params = params.append("empId",empId);
    return this.http.get<any>(`${environment.url}/ap3`, { params: params });
  }

  resetPassword(password : any, resetToken : any): Observable<any> {
    let url = `${environment.url}/resetpassword`;
    // let body = userVerify;
    // console.log(body)
    return this.http.put<any>(url,{password,resetToken});
  }

  getUserById(id: any) {
    return this.http.get<any>(`${environment.url}/apiUser/getUserById/` + id);
  }

  getMsUserByEmail(email: any) {
    return this.http.get<any>(
      `${environment.url}/apiUser/getMsUserByEmail/` + email
    );
  }

  sendMailTimesheet(
    id: any,
    empId: any,
    statusTimesheet: any
  ): Observable<any>{
    let params = new HttpParams();
    params = params.append("TsId", id);
    params = params.append("empId",empId);
    params = params.append("statusTimesheet",statusTimesheet)
    return this.http.get<any>(`${environment.url}/sendEmail`, { params: params });
  }
}
